import { defaultSender, dsFarmAppId } from "@/config";
import { AlgorandClient } from "@algorandfoundation/algokit-utils";
import {
  DSFarmParams,
  DSFarmSDK,
  DSFarmSDKConstructor,
} from "@myth-finance/dualstake-farm-sdk";
import algosdk from "algosdk";
import { algod } from "./algo";
import { useLifetimeStore } from "@/store/lifetime";

export const algorand = AlgorandClient.fromClients({ algod });
const { lifetime } = useLifetimeStore.getState();
algorand.setDefaultValidityWindow(lifetime);

export const setDefaultValidityWindow = (validity: number) => algorand.setDefaultValidityWindow(validity);

export const dsFarmConfig: DSFarmSDKConstructor = {
  appId: BigInt(dsFarmAppId),
  algorand,
  sender: defaultSender,
};

export const makeFarmClient = (
  args?: Partial<DSFarmSDKConstructor>
): DSFarmSDK => {
  return new DSFarmSDK({
    ...dsFarmConfig,
    ...args,
  });
};

export async function getFarmCreationCostAndDuration(
  args: Parameters<typeof DSFarmSDK.prototype.getFarmCreationCost>[0]
): Promise<string | DSFarmParams> {
  try {
    return await makeFarmClient().getFarmParams(args);
  } catch (e) {
    return `Error calculating cost: ${(e as Error).message}`;
  }
}

export async function makeCreateFarmTransactions(
  sender: string,
  params: Parameters<typeof DSFarmSDK.prototype.makeCreateFarmTransactions>[0]
) {
  const client = makeFarmClient({ sender });
  const etxns = await client.makeCreateFarmTransactions(params);
  return etxns.map((e) => algosdk.Transaction.from_obj_for_encoding(e));
}

export async function makeExtendAmountTransactions(
  sender: string,
  params: Parameters<
    typeof DSFarmSDK.prototype.makeExtendFarmAmountTransactions
  >[0]
) {
  const client = makeFarmClient({ sender });
  const etxns = await client.makeExtendFarmAmountTransactions(params);
  return etxns.map((e) => algosdk.Transaction.from_obj_for_encoding(e));
}

export async function makeExtendDurationTransactions(
  sender: string,
  params: Parameters<
    typeof DSFarmSDK.prototype.makeExtendFarmDurationTransactions
  >[0]
) {
  const client = makeFarmClient({ sender });
  const etxns = await client.makeExtendFarmDurationTransactions(params);
  return etxns.map((e) => algosdk.Transaction.from_obj_for_encoding(e));
}
